/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, CanBeSignals} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {forEachSelectorChildren, Selector} from './SelectChild';

export type SetVisibilityProps = CanBeSignals<{
    /**
     * Selector to set visibility.
     * Can be filtered bay `string`, `strong[]` that wil be used for `DisplayObject.name`.
     * Or a filter function.
     */
    selector: Selector;
}>;

/**
 * Set visibility for direct children of this component based on the selector.
 * Direct children will be processed by `name`, `name[]` or by a filter `function`.
 *
 * For example `props.mode: 'base'|'autoplay'|'free_spins'`:
 * ```tsx
 * <$SetVisibility selector={props.mode}>
 *     <$Spine name='base' animation={...}/>
 *     <$Sprite name='autoplay' texture='...'/>
 *     <$Container name='free_spins'>...</$Container>
 * </$SetVisibility
 * ```
 */
export const $SetVisibility: FC<SetVisibilityProps> = (props) => {
    return Store.computed(() => {
        forEachSelectorChildren(props, (item, isSelected) => {
            item.visible = isSelected;
        });

        return props.children;
    });
};